import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import Dropdown from 'react-bootstrap/Dropdown'
import Avatar1 from '../../../assets/avatar-4.png'
import { admin_logout } from '../../../redux/actions/adminAuthActions'

const NavRight = () => {
	const dispatch = useDispatch()

	const adminAuth = useSelector((state) => state.adminAuth)
	const { detail } = adminAuth

	const logoutHandler = (e) => {
		e.preventDefault()
		dispatch(admin_logout())
	}

	return (
		<ul className='navbar-nav ml-auto'>
			<li>
				<div className='pro-head'>
					<img src={Avatar1} className='dashboard_avatar' alt='User Profile' />
					<span> {detail && detail.name} </span>
				</div>
			</li>
			<li>
				<Dropdown className='drp-user'>
					<Dropdown.Toggle variant={'link'} id='dropdown-basic'>
						<i className='icon feather icon-settings' />
					</Dropdown.Toggle>
					<Dropdown.Menu alignRight className='profile-notification'>
						<ul className='pro-body'>
							<li>
								<Link to='/' className='dropdown-item'>
									<i className='feather icon-home' /> Home
								</Link>
							</li>
							<li>
								<Link to='/admin/dashboard/profile' className='dropdown-item'>
									<i className='feather icon-user' /> Profile
								</Link>
							</li>
							{/* <li>
								<Link to='/admin/dashboard/campaigns' className='dropdown-item'>
									<i className='feather icon-mail' /> My Messages
								</Link>
							</li> */}
							<li>
								<Link to='#' className='dropdown-item' onClick={logoutHandler}>
									<i className='feather icon-lock' /> Sign Out
								</Link>
							</li>
						</ul>
					</Dropdown.Menu>
				</Dropdown>
			</li>
		</ul>
	)
}

export default NavRight
